module.exports = __webpack_public_path__ + "img/2f_l_twodays@2x.b58d8f92.png";